import { useMemo } from 'react';
import { createLandingPageDependencies } from '@/app/landing/createLandingPageDependencies';

export const useLandingPage = () => {
  const deps = useMemo(() => createLandingPageDependencies(), []);
  const content = useMemo(() => deps.getLandingPageContent.execute(), [deps]);

  return { content };
};

